"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const aws_sdk_1 = require("aws-sdk");
class BillingClient {
    constructor(config, options) {
        this.config = config;
        this.options = options;
    }
    // -----------------------------------------------
    //    Public methods
    // -----------------------------------------------
    async track(event) {
        if (!this.config.billing || !this.config.billing.stream) {
            throw new Error('Billing is not configured.');
        }
        if (!this.firehose) {
            this.firehose = new aws_sdk_1.Firehose({ region: this.config.region });
        }
        const payload = {
            time: Date.now(),
            business: event.business,
            location: event.location,
            event: event.event,
            value: event.value,
        };
        await this.firehose.putRecord({
            DeliveryStreamName: this.config.billing.stream,
            Record: {
                Data: JSON.stringify(payload)
            }
        }).promise();
    }
}
exports.BillingClient = BillingClient;
